import { render } from "./taxLabels.vue?vue&type=template&id=2b94fd36"
import script from "./taxLabels.vue?vue&type=script&lang=js"
export * from "./taxLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__